// import React, { useEffect, useMemo, useRef } from "react";
// import "./SalesReturnReport.css";

// import SalesReturnReportHeader from "../SalesReturnReport/SalesReturnReportHeader/SalesReturnReportHeader";
// import SalesReturnReportFooter from "./SalesReturnReportFooter/SalesReturnReportFooter";
// import SalesReportFooter from "../SalesReport/SalesReportFooter/SalesReportFooter";
// import { useDispatch, useSelector } from "react-redux";
// import { ReadCookie } from "../../utils/readCookie";

// import {
//   getRAReportItem,
//   getRAReportPrint,
//   getRAReportColumnValue,
//   getRAReportColumn,
// } from "../../redux/actions/rAReport.action";
// import { Button, Spin } from "antd";
// import { useLocation } from "react-router-dom";
// import { getSaleReturnReport } from "../../redux/actions/saleRrutrnReport.action";
// import moment from "moment";


// const SalesReturnReport = () => {
//   const dispatch = useDispatch();
//   const menuId = ReadCookie("menuId");
//   const token = ReadCookie("token");
//   const {

//     RAPrint,
//     RAItem,
//     RAColumn,
//     RAColumnValue,
//   } = useSelector((state) => state);

//   function useQuery() {
//     const { search } = useLocation();
//     return React.useMemo(() => new URLSearchParams(search), [search]);
//   }

//   let query = useQuery();
//   let return_header_id = query.get("return_header_id");

//   const footerData = RAPrint && RAPrint?.payload?.data[0];



//   const sum = RAColumnValue?.payload?.data.reduce(
//     (acc, item, index) => acc + parseInt(item.item_quantity),
//     0
//   );
//   const totalAmount = RAPrint?.payload?.data[0]?.sum_gross_amount


//   let groupValues =
//     RAColumnValue &&
//     RAColumnValue?.payload?.data.reduce(function (r, a) {
//       r[a.gender_category_id] = r[a.gender_category_id] || [];
//       r[a.gender_category_id].push(a);
//       return r;
//     }, Object.create(null));

//   const groupedColumnValue = groupValues && Object.values(groupValues);

//   const values = {

//     return_header_id: return_header_id,
//   };

//   useEffect(() => {


//     dispatch(getRAReportItem(token, values));
//     dispatch(getRAReportPrint(token, values));
//     dispatch(getRAReportColumnValue(token, values));
//     dispatch(getRAReportColumn(token, values));
//   }, [dispatch, menuId, token]);

//   const myData = useMemo(() => {
//     return RAColumn?.payload?.data.map((it, i) => {
//       return {
//         column: it,
//         detail: groupedColumnValue && groupedColumnValue[i],
//       };
//     });
//   }, [groupedColumnValue, RAColumn]);

//  const handlePrint = () => {
//   const css = `
//     @page {
//       size: A4 landscape;
//       margin: 20px;
//     }
//     @media print {
//       body {
//         -webkit-print-color-adjust: exact; /* Optional: ensures color accuracy in print */
//       }
//     }
//   `;
//   const style = document.createElement('style');
//   style.innerHTML = css;
//   document.head.appendChild(style);

//   window.print();

//   document.head.removeChild(style); // Clean up after print
// };


//   return (
//     <div>
//       {footerData ? (
//         <div
//           className="sales_return_view"
//           style={{
//             display: "flex",
//             justifyContent: "center",
//           }}
//         >
//           <table>
//             <thead>
//               <tr>
//                 <td className="return-footer">
//                   <div>
//                     <SalesReturnReportHeader />
//                   </div>
//                 </td>
//               </tr>
//             </thead>
//             {!RAColumnValue.loading && (
//               <div className="no-print" style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '16px', marginRight: "114px" }}>
//                 <Button type="primary" onClick={handlePrint}>
//                   Print
//                 </Button>
//               </div>
//             )}
//             <tbody>
//               <tr>
//                 <td>
//                   <div className="content-block">
//                     <div className="sales-report-Table-data mt-0">
//                       {myData?.map((size, index) => {
//                         return (
//                           <table className="sales-report-table-return">
//                             <tbody>
//                               <tr>
//                                 <td
//                                   className="font_weight"
//                                   style={{
//                                     width: "36px",
//                                   }}
//                                 >
//                                   S.No
//                                 </td>
//                                 <td
//                                   className="font_weight"
//                                   style={{
//                                     width: "88px",
//                                   }}
//                                 >
//                                   SKU #
//                                 </td>
//                                 <td
//                                   className="font_weight"
//                                   style={{
//                                     width: "240px",
//                                   }}
//                                 >
//                                   Style/Desc
//                                   <span style={{ marginLeft: "5px" }}>
//                                     {size?.column?.gender_category_name}
//                                   </span>
//                                 </td>
//                                 <td
//                                   key={index}
//                                   className="sales_table_col font_weight text-center pl-0"
//                                 >
//                                   {size.column.hq23 && size.column.hq23}
//                                 </td>
//                                 <td className="sales_table_col font_weight text-center pl-0">
//                                   {size.column.hq24 && size.column.hq24}
//                                 </td>
//                                 <td className="sales_table_col font_weight text-center pl-0">
//                                   {size.column.hq25 && size.column.hq25}
//                                 </td>
//                                 <td className="sales_table_col font_weight text-center pl-0">
//                                   {size.column.hq26 && size.column.hq26}
//                                 </td>
//                                 <td className="sales_table_col font_weight text-center pl-0">
//                                   {size.column.hq27 && size.column.hq27}
//                                 </td>
//                                 <td className="sales_table_col font_weight text-center pl-0">
//                                   {size.column.hq28 && size.column.hq28}
//                                 </td>
//                                 <td className="sales_table_col font_weight text-center pl-0">
//                                   {size.column.hq29 && size.column.hq29}
//                                 </td>
//                                 <td className="sales_table_col font_weight text-center pl-0">
//                                   {size.column.hq30 && size.column.hq30}
//                                 </td>
//                                 <td className="sales_table_col font_weight text-center pl-0">
//                                   {size.column.hq31 && size.column.hq31}
//                                 </td>
//                                 <td className="sales_table_col font_weight text-center pl-0">
//                                   {size.column.hq32 && size.column.hq32}
//                                 </td>
//                                 <td className="sales_table_col font_weight text-center pl-0">
//                                   {size.column.hq33 && size.column.hq33}
//                                 </td>
//                                 <td className="sales_table_col font_weight text-center pl-0">
//                                   {size.column.hq34 && size.column.hq34}
//                                 </td>
//                                 <td className="sales_table_col font_weight text-center pl-0">
//                                   {size.column.hq35 && size.column.hq35}
//                                 </td>
//                                 <td className="sales_table_col font_weight text-center pl-0">
//                                   {size.column.hq36 && size.column.hq36}
//                                 </td>
//                                 <td className="sales_table_col font_weight text-center pl-0">
//                                   {size.column.hq37 && size.column.hq37}
//                                 </td>
//                                 <td className="sales_table_col font_weight text-center pl-0">
//                                   {size.column.hq38 && size.column.hq38}
//                                 </td>
//                                 <td
//                                   className="font_weight"
//                                   style={{
//                                     width: "50px",
//                                   }}
//                                 >
//                                   Quantity
//                                 </td>
//                                 <td
//                                   className="font_weight"
//                                   style={{
//                                     width: "50px",
//                                   }}
//                                 >
//                                   Rate
//                                 </td>
//                                 <td
//                                   className="font_weight"
//                                   style={{
//                                     width: "80px",
//                                   }}
//                                 >
//                                   Amount
//                                 </td>
//                               </tr>
//                               {/* dummy data */}

//                               {size.detail?.map((it, index) => {
//                                 return (
//                                   <tr>
//                                     <td>{index + 1}</td>
//                                     <td
//                                       style={{
//                                         marginLeft: "0",
//                                       }}
//                                     >
//                                       {it.item_code}
//                                     </td>
//                                     <td>{it.description}</td>
//                                     <td className="text-center pl-0">
//                                       {it.q23 && it.q23}
//                                     </td>
//                                     <td className="text-center pl-0">
//                                       {it.q24 && it.q24}
//                                     </td>
//                                     <td className="text-center pl-0">
//                                       {it.q25 && it.q25}
//                                     </td>
//                                     <td className="text-center pl-0">
//                                       {it.q26 && it.q26}
//                                     </td>
//                                     <td className="text-center pl-0">
//                                       {it.q27 && it.q27}
//                                     </td>
//                                     <td className="text-center pl-0">
//                                       {it.q28 && it.q28}
//                                     </td>
//                                     <td className="text-center pl-0">
//                                       {it.q29 && it.q29}
//                                     </td>
//                                     <td className="text-center pl-0">
//                                       {it.q30 && it.q30}
//                                     </td>
//                                     <td className="text-center pl-0">
//                                       {it.q31 && it.q31}
//                                     </td>
//                                     <td className="text-center pl-0">
//                                       {it.q32 && it.q32}
//                                     </td>
//                                     <td className="text-center pl-0">
//                                       {it.q33 && it.q33}
//                                     </td>
//                                     <td className="text-center pl-0">
//                                       {it.q34 && it.q34}
//                                     </td>
//                                     <td className="text-center pl-0">
//                                       {it.q35 && it.q35}
//                                     </td>
//                                     <td className="text-center pl-0">
//                                       {it.q36 && it.q36}
//                                     </td>
//                                     <td className="text-center pl-0">
//                                       {it.q37 && it.q37}
//                                     </td>
//                                     <td className="text-center pl-0">
//                                       {it.q38 && it.q38}
//                                     </td>
//                                     <td>
//                                       {it.item_quantity && it.item_quantity}
//                                     </td>
//                                     <td className="text-center pl-0">
//                                       $ {it.rate && it.rate}
//                                     </td>
//                                     <td>$ {it.amount && it.amount}</td>
//                                   </tr>
//                                 );
//                               })}
//                             </tbody>
//                           </table>
//                         );
//                       })}
//                       <div style={{ display: "flex", justifyContent: "space-between" }}>

//                         <div
//                           style={{
//                             paddingTop: "5px",
//                           }}
//                         >
//                           * Invoice dates are respectively to invoice No
//                         </div>

//                         <table className="sales-return-table-total">
//                           <tbody>
//                             <tr className="font_weight">
//                               <td
//                                 style={{
//                                   width: "30px",
//                                   textAlign: "right",
//                                   paddingRight: "10px",
//                                 }}
//                                 className="font_weight total_cell"
//                               >
//                                 Total Unit
//                               </td>
//                               <td
//                                 className="sum_cell"
//                                 style={{
//                                   width: "30px",
//                                 }}
//                               >
//                                 {sum}
//                               </td>
//                             </tr>
//                             <tr className="font_weight">
//                               <td
//                                 style={{
//                                   width: "30px",
//                                   textAlign: "right",
//                                   paddingRight: "10px",
//                                 }}
//                                 className="font_weight total_cell"
//                               >
//                                  Amount
//                               </td>
//                               <td
//                                 className="sum_cell"
//                                 style={{
//                                   width: "30px",
//                                 }}
//                               >
//                                 {'$ ' + totalAmount}
//                               </td>
//                             </tr>
//                             <tr className="font_weight">
//                               <td
//                                 style={{
//                                   width: "30px",
//                                   textAlign: "right",
//                                   paddingRight: "10px",
//                                 }}
//                                 className="font_weight total_cell"
//                               >
//                                 Disc %
//                               </td>
//                               <td
//                                 className="sum_cell"
//                                 style={{
//                                   width: "30px",
//                                 }}
//                               >
//                                 {footerData && Number(footerData.discount_percent).toFixed(2)} %
//                               </td>
//                             </tr>
//                             <tr className="font_weight">
//                               <td
//                                 style={{
//                                   width: "30px",
//                                   textAlign: "right",
//                                   paddingRight: "10px",
//                                 }}
//                                 className="font_weight total_cell"
//                               >
//                                 Disc Amount
//                               </td>
//                               <td
//                                 className="sum_cell"
//                                 style={{
//                                   width: "30px",
//                                 }}
//                               >
//                                 $ {footerData && Number(footerData.discount).toFixed(2)}
//                               </td>
//                             </tr>
//                             <tr className="font_weight">
//                               <td
//                                 style={{
//                                   width: "30px",
//                                   textAlign: "right",
//                                   paddingRight: "10px",
//                                 }}
//                                 className="font_weight total_cell"
//                               >
//                                 Tax Amount
//                               </td>
//                               <td
//                                 className="sum_cell"
//                                 style={{
//                                   width: "30px",
//                                 }}
//                               >
//                                 $ {footerData && Number(footerData.tax_amount).toFixed(2)}
//                               </td>
//                             </tr>


//                             <tr className="font_weight">
//                               <td
//                                 style={{
//                                   width: "30px",
//                                   textAlign: "right",
//                                   paddingRight: "10px",
//                                 }}
//                                 className="font_weight total_cell"
//                               >
//                                 Return Label Fee
//                               </td>
//                               <td
//                                 className="sum_cell"
//                                 style={{
//                                   width: "30px",
//                                 }}
//                               >
//                                 $ {footerData && Number(footerData.return_label_fee).toFixed(2)}
//                               </td>
//                             </tr>
//                             <tr className="font_weight">
//                               <td
//                                 style={{
//                                   width: "30px",
//                                   textAlign: "right",
//                                   paddingRight: "10px",
//                                 }}
//                                 className="font_weight total_cell"
//                               >
//                                 Net Amount
//                               </td>
//                               <td
//                                 className="sum_cell"
//                                 style={{
//                                   width: "30px",
//                                 }}
//                               >
//                                 $ {footerData && Number(footerData.net_amount).toFixed(2)}
//                               </td>
//                             </tr>
//                             <tr className="font_weight">
//                               <td
//                                 style={{
//                                   width: "30px",
//                                   textAlign: "right",
//                                   paddingRight: "10px",
//                                 }}
//                                 className="font_weight total_cell"
//                               >
//                                 RA Expire Date:
//                               </td>
//                               <td
//                                 className="sum_cell"
//                                 style={{
//                                   width: "30px",
//                                 }}
//                               >
//                                 {footerData && moment(footerData.expiry_date).format("MM-DD-YYYY")}
//                               </td>
//                             </tr>
//                           </tbody>
//                         </table>
//                       </div>
//                       <table
//                         className="return_sales_person_table"

//                       >
//                         { }
//                         <tbody>
//                           <tr
//                             style={{
//                               borderBottom: "1px solid black",
//                             }}
//                             className="font_weight "
//                           >
//                             <td className="font_weight total_cell">Reason:</td>
//                             <td
//                               className="sum_cell"
//                               style={{

//                               }}
//                             >
//                               {footerData && footerData.memo}
//                             </td>
//                           </tr>
//                           <tr
//                             style={{
//                               borderBottom: "1px solid black",
//                             }}
//                             className="font_weight"
//                           >
//                             <td

//                               style={{
//                                 width: "15%",
//                               }} className="font_weight "
//                             >
//                               Sale Person:
//                             </td>
//                             <td

//                               style={{
//                                 width: "100%",
//                               }}
//                             >
//                               {footerData && footerData.salesperson_name}
//                             </td>
//                           </tr>
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>

//                   {/* <div>
//                   <div className="signature">
//                     Authorized Signature
//                   </div>
//                 </div> */}
//                 </td>
//               </tr>
//             </tbody>
//             <tfoot>
//               <tr>
//                 <td className="return-footer2">
//                   <div 
//                   // className="sales-report-footer"
//                    >
//                     <SalesReturnReportFooter locationId={RAPrint?.payload?.data[0]?.location_id} />
//                   </div>
//                 </td>
//               </tr>
//             </tfoot>
//           </table>
//         </div>
//       ) : (
//         <div className="spin">
//           <Spin size="large" />
//         </div>
//       )}
//     </div>
//   );
// };

// export default SalesReturnReport;




import React, { useEffect, useMemo } from "react";
import "./SalesReturnReport.css";

import SalesReturnReportHeader from "../SalesReturnReport/SalesReturnReportHeader/SalesReturnReportHeader";
import SalesReturnReportFooter from "./SalesReturnReportFooter/SalesReturnReportFooter";
import { useDispatch, useSelector } from "react-redux";
import {
  getRAReportItem,
  getRAReportPrint,
  getRAReportColumnValue,
  getRAReportColumn,
} from "../../redux/actions/rAReport.action";
import { Button } from "antd";
import { useLocation } from "react-router-dom";
import moment from "moment";
import Loader from "react-loader-spinner";
import { ReadCookie } from "../../utils/readCookie";

const SalesReturnReport = () => {
  const dispatch = useDispatch();
  const {
    RAPrint,
    RAColumn,
    RAColumnValue,
  } = useSelector((state) => state);
  const menuId = ReadCookie("menuId");
  const token = ReadCookie("token");
  function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }

  let query = useQuery();
  let return_header_id = query.get("return_header_id");

  const footerData = RAPrint && RAPrint?.payload?.data[0];

  let groupValues =
    RAColumnValue &&
    RAColumnValue?.payload?.data.reduce(function (r, a) {
      r[a.gender_category_id] = r[a.gender_category_id] || [];
      r[a.gender_category_id].push(a);
      return r;
    }, Object.create(null));

  const groupedColumnValue = groupValues && Object.values(groupValues);

  const values = {
    return_header_id: return_header_id,
  };


  useEffect(() => {
    dispatch(getRAReportItem(token, values));
    dispatch(getRAReportPrint(token, values));
    dispatch(getRAReportColumnValue(token, values));
    dispatch(getRAReportColumn(token, values));
  }, [dispatch, menuId, token]);

  const myData = useMemo(() => {
    return RAColumn?.payload?.data.map((it, i) => {
      return {
        column: it,
        detail: groupedColumnValue && groupedColumnValue[i],
      };
    });
  }, [groupedColumnValue, RAColumn]);

  const handlePrint = () => {
    const css = '@page { size: A4 landscape; margin: 2mm 10mm !important;}';
    const style = document.createElement('style');
    style.innerHTML = css;
    document.head.appendChild(style);
    window.print();
    document.head.removeChild(style); // Clean up after print
  };

  if (RAPrint?.loading) {
    return <>
      <div className='loaderDiv' >
        <Loader
          type="Grid"
          color="#212121"
          height={40}
          width={40}
        />
      </div>
    </>
  }



  return (
    <div className="__sale_return_auth_report">
      <table width="100%">
        <thead>
          <tr>
            <td>
              <SalesReturnReportHeader />
            </td>
          </tr>
        </thead>
        <tbody>
          <tr className="no-print">
            <td>
              <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '16px', marginRight: "114px" }}>
                <Button type="primary" onClick={handlePrint}>
                  Print
                </Button>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <Body myData={myData} footerData={footerData} />
              <SalesReturnReportFooter locationId={RAPrint?.payload?.data[0]?.location_id} />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const Body = ({ myData, footerData }) => {
  return (
    <>
      <div className="__content">
        <div className="__list_items">
          {myData?.map((size, index) => {
            return (
              <table key={index} width="100%">
                <tbody>
                  <tr>
                    <th
                      style={{
                        width: "36px",
                      }}
                    >
                      S.No
                    </th>
                    <th
                      style={{
                        width: "88px",
                      }}
                    >
                      SKU #
                    </th>
                    {/* <th
                      style={{
                        width: "80px",
                      }}
                    >
                      Brand
                    </th> */}
                    <th
                      style={{
                        width: "240px",
                      }}
                    >
                      Style/Desc
                      <span style={{ marginLeft: "5px" }}>
                        {size?.column?.gender_category_name}
                      </span>
                    </th>
                    <th
                      className="__size_col"
                    >
                      {size.column.hq23 && size.column.hq23}
                    </th>
                    <th className="__size_col">
                      {size.column.hq24 && size.column.hq24}
                    </th>
                    <th className="__size_col">
                      {size.column.hq25 && size.column.hq25}
                    </th>
                    <th className="__size_col">
                      {size.column.hq26 && size.column.hq26}
                    </th>
                    <th className="__size_col">
                      {size.column.hq27 && size.column.hq27}
                    </th>
                    <th className="__size_col">
                      {size.column.hq28 && size.column.hq28}
                    </th>
                    <th className="__size_col">
                      {size.column.hq29 && size.column.hq29}
                    </th>
                    <th className="__size_col">
                      {size.column.hq30 && size.column.hq30}
                    </th>
                    <th className="__size_col">
                      {size.column.hq31 && size.column.hq31}
                    </th>
                    <th className="__size_col">
                      {size.column.hq32 && size.column.hq32}
                    </th>
                    <th className="__size_col">
                      {size.column.hq33 && size.column.hq33}
                    </th>
                    <th className="__size_col">
                      {size.column.hq34 && size.column.hq34}
                    </th>
                    <th className="__size_col">
                      {size.column.hq35 && size.column.hq35}
                    </th>
                    <th className="__size_col">
                      {size.column.hq36 && size.column.hq36}
                    </th>
                    <th className="__size_col">
                      {size.column.hq37 && size.column.hq37}
                    </th>
                    <th className="__size_col">
                      {size.column.hq38 && size.column.hq38}
                    </th>
                    <th
                      style={{
                        width: "50px",
                      }}
                    >
                      Quantity
                    </th>
                    <th
                      style={{
                        width: "90px",
                      }}
                    >
                      Rate
                    </th>
                    <th
                      style={{
                        width: "90px",
                      }}
                    >
                      Amount
                    </th>
                  </tr>
                  {size.detail?.map((it, index) => {
                    return (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td
                          style={{
                            marginLeft: "0",
                          }}
                        >
                          {it.item_code}
                        </td>
                        {/* <td>
                          {it?.sku_brand_name}
                        </td> */}
                        <td>
                          {it.description}
                        </td>
                        <td className="__size_col">
                          {it.q23 && Number(it.q23).toFixed(0)}
                        </td>
                        <td className="__size_col">
                          {it.q24 && Number(it.q24).toFixed(0)}
                        </td>
                        <td className="__size_col">
                          {it.q25 && Number(it.q25).toFixed(0)}
                        </td>
                        <td className="__size_col">
                          {it.q26 && Number(it.q26).toFixed(0)}
                        </td>
                        <td className="__size_col">
                          {it.q27 && Number(it.q27).toFixed(0)}
                        </td>
                        <td className="__size_col">
                          {it.q28 && Number(it.q28).toFixed(0)}
                        </td>
                        <td className="__size_col">
                          {it.q29 && Number(it.q29).toFixed(0)}
                        </td>
                        <td className="__size_col">
                          {it.q30 && Number(it.q30).toFixed(0)}
                        </td>
                        <td className="__size_col">
                          {it.q31 && Number(it.q31).toFixed(0)}
                        </td>
                        <td className="__size_col">
                          {it.q32 && Number(it.q32).toFixed(0)}
                        </td>
                        <td className="__size_col">
                          {it.q33 && Number(it.q33).toFixed(0)}
                        </td>
                        <td className="__size_col">
                          {it.q34 && Number(it.q34).toFixed(0)}
                        </td>
                        <td className="__size_col">
                          {it.q35 && Number(it.q35).toFixed(0)}
                        </td>
                        <td className="__size_col">
                          {it.q36 && Number(it.q36).toFixed(0)}
                        </td>
                        <td className="__size_col">
                          {it.q37 && Number(it.q37).toFixed(0)}
                        </td>
                        <td className="__size_col">
                          {it.q38 && Number(it.q38).toFixed(0)}
                        </td>
                        <td>
                          {it.item_quantity && it.item_quantity}
                        </td>
                        <td>$ {it.rate && Number(it.rate).toFixed(2)}</td>
                        <td>$ {it.amount && Number(it.amount).toFixed(2)}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            );
          })}
        </div>
        <div className="__summary_box">
          <table width="100%">
            <tbody>
              <tr>
                <td valign="top">
                  <p>* Invoice dates are respectively to invoice No</p>
                  <p className="__reason_box"><span className="font-weig">Reason:</span> {footerData && footerData.memo}</p>
                  <p className="__reason_box"><span className="font-weig">Sale Person:</span> {footerData && footerData.salesperson_name}</p>
                </td>
                 
                <td width="280px">
                  <table width="100%" className="__summary_box_table">
                    <tbody>
                      <tr>
                        <td width="60%">Total Unit</td>
                        <td width="40%">{footerData && Number(footerData.sum_quantity)}</td>
                      </tr>
                      <tr>
                        <td>
                          Amount
                        </td>
                        <td>
                          $ {footerData && Number(footerData.sum_gross_amount).toFixed(2)}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          Disc %
                        </td>
                        <td>{footerData && Number(footerData.discount_percent).toFixed(2)} %</td>
                      </tr>
                      <tr>
                        <td>
                          Disc Amount
                        </td>
                        <td>$ {footerData && Number(footerData.discount).toFixed(2)}</td>
                      </tr>
                      <tr>
                        <td>
                          Tax Amount
                        </td>
                        <td>$ {footerData && Number(footerData.tax_amount).toFixed(2)}</td>
                      </tr>
                      <tr>
                        <td>
                          Return Label Fee
                        </td>
                        <td>$ {footerData && Number(footerData.return_label_fee).toFixed(2)}</td>
                      </tr>
                      <tr>
                        <td>
                          Net Amount
                        </td>
                        <td>$ {footerData && Number(footerData.net_amount).toFixed(2)}</td>
                      </tr>
                      <tr>
                        <td>
                          RA Expire Date:
                        </td>
                        <td>{footerData && moment(footerData.expiry_date).format("MM-DD-YYYY")}</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  )
}

export default SalesReturnReport;
